__webpack_require__.p = "https://app.picklinq.com/";